// Agency highlights (public) — preuve sociale pour les créateurs hors agence.
// Adapté de Black OS. Lit get_black_public_agency_stats() (compteurs NON
// sensibles ; les diamants/USD sont chiffrés AES → non exposés, R2). i18n.
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { t } from '../../utils/creatorLang';
import {
  CreatorScreen, ScreenHeader, Card, StatTile, SectionLabel, BottomNav, I,
} from '../../components/creator/primitives';
import { PublicSettingsButton } from '../../components/creator/PublicSettingsButton';

const fmtNum = (n) => {
  if (n == null) return '—';
  const v = Number(n);
  if (v >= 1_000_000) return (v / 1_000_000).toFixed(1) + 'M';
  if (v >= 1_000) return (v / 1_000).toFixed(1) + 'k';
  return v.toLocaleString('en-US');
};

const AgencyStats = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data, error } = await supabase.rpc('get_black_public_agency_stats');
        if (cancelled) return;
        if (error) setError(true);
        else setStats(Array.isArray(data) ? data[0] : data);
      } catch {
        if (!cancelled) setError(true);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <CreatorScreen>
      <ScreenHeader title={t('pub_agency_highlights')} subtitle={t('pub_ag_subtitle')} onBack={() => navigate('/my/public-dashboard')} right={<PublicSettingsButton />} />

      <div style={{ padding: '16px 20px 96px', display: 'flex', flexDirection: 'column', gap: 16 }}>
        <Card pad={16}>
          <div style={{ fontSize: 13, color: 'var(--fg-2)', lineHeight: 1.55 }}>{t('pub_ag_intro')}</div>
        </Card>

        {!stats && !error && (
          <Card pad={16}><div style={{ height: 48, borderRadius: 8, background: 'var(--bg-3)', opacity: 0.6 }} /></Card>
        )}
        {error && (
          <Card pad={16}><div style={{ fontSize: 12, color: 'var(--fg-3)' }}>{t('pub_ag_unavailable')}</div></Card>
        )}

        {stats && (
          <div>
            <SectionLabel>{t('pub_ag_coverage')}</SectionLabel>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 8 }}>
              <StatTile label={t('pub_ag_creators')} value={fmtNum(stats.creators_total_lifetime)} />
              <StatTile label={t('pub_ag_servers')} value={stats.active_servers ?? '—'} />
              <StatTile label={t('pub_ag_regions')} value={stats.countries_covered ?? '—'} />
              <StatTile label={t('pub_ag_support')} value="24/7" />
            </div>
          </div>
        )}

        <button onClick={() => navigate('/my/apply')} style={{ marginTop: 4, padding: '14px 16px', borderRadius: 12, background: 'var(--accent-pink)', color: '#fff', border: 'none', fontSize: 13, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
          <I.Sparkle size={14} stroke="currentColor" /> {t('pub_ag_apply')}
        </button>

        <div style={{ padding: '10px 14px', borderRadius: 10, background: 'var(--bg-2)', border: '1px solid var(--line-1)', fontSize: 10, color: 'var(--fg-3)', lineHeight: 1.5, textAlign: 'center' }}>
          {t('pub_ag_disclaimer')}
        </div>
      </div>

      <BottomNav active="agency-stats" variant="public" />
    </CreatorScreen>
  );
};

export default AgencyStats;
